import apiRequestService from '@/commonProject/service/apiRequestService';

export default class CompanyRepository {
    /**
     * 企業情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getCompanyApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/cmp', requestBody, idToken);
        return result;
    }
}
